app.ui.registerUi('dropdown', function (app) {
    var helpers = app.helpers.funcs;
    return {
        implementationExists: function () {
            return true; // Implementation exists within file
        },
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {

            var scope = this;

            var $selectElems = helpers.resolveScope('select', $scope);
            var useCustomScrollbars = app.data.get('config.dropdownBars');

            $selectElems.each(function (k, elem) {
                var $elem = $(elem);
                $elem.wrap('<div class="select-wrap"></div>');
            });

            // Immediate adjust class instructions
            $selectElems.each(function (k, elem) {
                var $elem = $(elem);

                $elem.focus(function (e) {
                    var optionIsDisabled = $('option:selected', this).attr('disabled');

                    if (optionIsDisabled) {
                        $elem.prop('selectedIndex', -1)
                    }
                });

                // Add filled class to the dropdown if it is populated by the server
                // prior to page load
                scope.adjustClass($elem);

                // Add class when filled to stop form label from moving back down and eclipsing the selected value.
                $elem.change(function (e) {
                    $elem = $(this);
                    scope.adjustClass($elem);
                });
            });
        },
        adjustClass: function ($elem) {
            var val = $elem.val();
            val = val === ' ' ? false : val;
            val = val ? true : false;
            var $selectWrapContainer = $elem.closest('.select-wrap');
            if (val) {
                $elem.addClass('filled');
                if ($selectWrapContainer.length) $selectWrapContainer.addClass('filled');
            } else {
                $elem.removeClass('filled');
                if ($selectWrapContainer.length) $selectWrapContainer.removeClass('filled');
            }
        }
    };
});

